(function () {
  function syncPlayPause(btn, paused) {
    btn.dataset.state = paused ? 'paused' : 'playing';
    btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
  }

  function syncMute(btn, muted) {
    btn.dataset.state = muted ? 'muted' : 'unmuted';
    btn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
  }

  function attachVideoEvents(dm, video) {
    const playPauseBtn = dm.querySelector('.pdp-video-controls__play-pause');
    const muteBtn = dm.querySelector('.pdp-video-controls__mute');

    if (playPauseBtn) {
      syncPlayPause(playPauseBtn, video.paused);
      video.addEventListener('play', function () { syncPlayPause(playPauseBtn, false); });
      video.addEventListener('pause', function () { syncPlayPause(playPauseBtn, true); });
    }

    if (muteBtn) {
      syncMute(muteBtn, video.muted);
      video.addEventListener('volumechange', function () { syncMute(muteBtn, video.muted); });
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
      });
    }

    // Click anywhere on deferred-media to toggle play/pause
    // Mute button stopPropagation prevents this from firing when mute is clicked
    dm.addEventListener('click', function () {
      video.paused ? video.play() : video.pause();
    });
  }

  function watchDeferredMedia(dm) {
    var existing = dm.querySelector('video');
    if (existing) {
      attachVideoEvents(dm, existing);
      return;
    }
    var observer = new MutationObserver(function (mutations, obs) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          if (nodes[j].tagName === 'VIDEO') {
            attachVideoEvents(dm, nodes[j]);
            obs.disconnect();
            return;
          }
        }
      }
    });
    observer.observe(dm, { childList: true });
  }

  function init() {
    document.querySelectorAll('deferred-media').forEach(watchDeferredMedia);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
